<div *ngIf="heeftOndernemingen()">

    <form [formGroup]="ondernemerForm">

        <div class="row align-items-start">
            <div class="col-7">
                <p>
                    Besteedt
                    {{ !partnerBoolean ? dataService.naamAangever : dataService.naamPartner }}
                    in {{ incomeTaxEntity.aangifte?.aangifteJaar }}
                    tenminste 1.225 uur aan de onderneming (zelfstandigenaftrek)?
                </p>
            </div>
            <div class="col-2">
                <snelstart-ui-select-form-control
                        (change)="saveForm()"
                        [options]="optionsJaNee"
                        class="custom-input-150"
                        formControlName="krijgtZelfstandigenAftrek"
                        id="krijgtZelfstandigenAftrek"
                ></snelstart-ui-select-form-control>
            </div>
            <div class="col-3"></div>
        </div>

        <div *ngIf="ondernemerForm.get('krijgtZelfstandigenAftrek')?.value === true"
             class="row align-items-start">
            <div class="col-7">
                <p>
                    Heeft {{ !partnerBoolean ? dataService.naamAangever : dataService.naamPartner }}
                    in {{ incomeTaxEntity.aangifte?.aangifteJaar }} recht op startersaftrek?
                </p>
            </div>
            <div class="col-2">
                <snelstart-ui-select-form-control
                        (change)="saveForm()"
                        [options]="optionsNeeJa"
                        class="custom-input-150"
                        formControlName="krijgtStartersAftrek"
                        id="krijgtStartersAftrek"
                ></snelstart-ui-select-form-control>
            </div>
            <div class="col-3"></div>
        </div>

        <div *ngIf="ondernemerForm.get('krijgtZelfstandigenAftrek')?.value === false"
             class="row align-items-start">
            <div class="col-7">
                <p>
                    Heeft {{ !partnerBoolean ? dataService.naamAangever : dataService.naamPartner }}
                    in {{ incomeTaxEntity.aangifte?.aangifteJaar }} recht op startersaftrek bij arbeidsongeschiktheid?
                </p>
            </div>
            <div class="col-2">
                <snelstart-ui-select-form-control
                        (change)="saveForm()"
                        [options]="optionsNeeJa"
                        class="custom-input-150"
                        formControlName="krijgtStartersAftrekBijArbeidsOngeschiktheid"
                        id="krijgtStartersAftrekBijArbeidsOngeschiktheid"
                ></snelstart-ui-select-form-control>
            </div>
            <div class="col-3"></div>
        </div>

        <div *ngIf="ondernemerForm.get('krijgtStartersAftrekBijArbeidsOngeschiktheid')?.value === true || ondernemerForm.get('krijgtStartersAftrek')?.value === true"
             class="row align-items-start">
            <div class="col-7">
                <p>
                    Aantal keren startersaftrek in de jaren {{ aangifte.aangifteJaar - 1 }}
                    - {{ aangifte.aangifteJaar - 6 }}
                </p>
            </div>
            <div class="col-2">
                <snelstart-ui-select-form-control
                        (change)="saveForm()"
                        [options]="aantalKerenBijAO"
                        class="custom-input-150"
                        formControlName="aantalKerenStartersaftrekBijAOToegepastInAfgelopenVijfJaar"
                ></snelstart-ui-select-form-control>
            </div>
            <div class="col-3"></div>
        </div>

        <div class="row align-items-start">
            <div class="col-7">
                <p> Heeft {{ !partnerBoolean ? dataService.naamAangever : dataService.naamPartner }}
                    een restant zelfstandigenaftrek voorgaande jaren?
                </p>
            </div>
            <div class="col-2">
                    <div *ngIf="restantZelfstandigenaftrekUitEerdereJaren.length === 0">
                        <snelstart-ui-button
                                (click)="addRijRestantZA()"
                                class="custom-input-150"
                                icon="plus"
                                id="invulRestant"
                                type="secondary">
                        Restant invullen
                        </snelstart-ui-button>
                    </div>
                    <div *ngIf="restantZelfstandigenaftrekUitEerdereJaren.length > 0">
                        <snelstart-ui-button
                                (click)="addRijRestantZA()"
                                class="custom-input-150"
                                icon="plus"
                                [disabled]="true"
                                id="invulRestant"
                                type="secondary">
                            Specificeren
                        </snelstart-ui-button>
                    </div>
            </div>
            <div class="col-3"></div>
        </div>

    </form>

    <form [formGroup]="restantZAFg">
        <div *ngIf="restantZelfstandigenaftrekUitEerdereJaren.length > 0" class="pb-2"
             formArrayName="restantZelfstandigenaftrekUitEerdereJaren">
            <div *ngFor="let restant of restantZelfstandigenaftrekUitEerdereJaren.controls; let i = index"
                 [formGroupName]="i"
                 class="row">

                <snelstart-ui-text-form-control
                        (change)="saveForm()"
                        [label]="i === 0 ? 'Omschrijving restant' : ''"
                        class="custom-input-250 col-auto"
                        formControlName="omschrijving"
                        id="omschrijving"
                ></snelstart-ui-text-form-control>

                <snelstart-ui-number-form-control
                        (change)="saveForm()"
                        [decimals]="0"
                        [label]="i === 0 ? 'Bedrag' : ''"
                        [minValue]="1"
                        align="right"
                        class="custom-input-150 col-auto"
                        formControlName="bedrag"
                        prefix="€"
                ></snelstart-ui-number-form-control>

                <snelstart-ui-button
                        (click)="verwijderRijRestantZA(i)"
                        [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                        class="delete"
                        icon="trash"
                        id="buttonDelete"
                        size="medium"
                        type="secondary"
                ></snelstart-ui-button>

            </div>
            <snelstart-ui-button
                    (click)="addRijRestantZA()"
                    class="custom-input-100"
                    icon="plus"
                    id="invulRestant"
                    type="link"

            >
                <div>
                    Toevoegen
                </div>

            </snelstart-ui-button>
        </div>
    </form>


    <form [formGroup]="ondernemerForm" class="pt-2">
        <div *ngIf="ondernemerForm.get('krijgtZelfstandigenAftrek')?.value === true">

            <div *ngIf="aangifte.gezamenlijkeAangifte || aangifte.gezamenlijkeAangifte!"
                 class="row align-items-start">
                <div class="col-7">
                    <p>
                        Werkt {{ !partnerBoolean ? dataService.naamPartner : dataService.naamAangever }}
                        in {{ incomeTaxEntity.aangifte?.aangifteJaar }}
                        mee in de onderneming
                        van {{ !partnerBoolean ? dataService.naamAangever : dataService.naamPartner }}
                        ?
                    </p>
                </div>
                <div class="col-2">
                    <snelstart-ui-select-form-control
                            (change)="saveForm()"
                            [options]="meewerkUren"
                            class="custom-input-150"
                            formControlName="meewerkUren"
                    ></snelstart-ui-select-form-control>
                </div>
                <div class="col-3"></div>
            </div>

            <div class="row align-items-start">
                <div class="col-7">
                    <p>
                        Heeft{{ !partnerBoolean ? dataService.naamAangever : dataService.naamPartner }}
                        in {{ incomeTaxEntity.aangifte?.aangifteJaar }} recht op aftrek voor speur- en
                        ontwikkelingswerk?
                    </p>
                </div>
                <div class="col-2">
                    <snelstart-ui-select-form-control
                            (change)="saveForm()"
                            [options]="optionsNeeJa"
                            class="custom-input-150"
                            formControlName="krijgtSenOaftrek"
                            id="krijgtSenOaftrek"
                    ></snelstart-ui-select-form-control>
                </div>
                <div class="col-3"></div>
            </div>

            <div *ngIf="ondernemerForm.get('krijgtSenOaftrek')?.getRawValue() === true"
                 class="row align-items-start">
                <div class="col-7">
                    <p>
                        Is er in {{ incomeTaxEntity.aangifte?.aangifteJaar }}
                        recht op verhoging van de aftrek voor speur- en ontwikkelingswerk?
                    </p>
                </div>
                <div class="col-2">
                    <snelstart-ui-select-form-control
                            (change)="saveForm()"
                            [options]="optionsJaNee"
                            class="custom-input-150"
                            formControlName="krijgtVerhogingSenOAftrek"
                            id="krijgtVerhogingSenOAftrek"
                    ></snelstart-ui-select-form-control>
                </div>
                <div class="col-3"></div>
            </div>

            <div *ngIf="ondernemerForm.get('krijgtSenOaftrek')?.getRawValue() === true"
                 class="row align-items-start">
                <div class="col-7">
                    <p>Vul het S&amp;O-nummer in</p>
                </div>
                <div class="col-2">
                    <snelstart-ui-text-form-control
                            (change)="saveForm()"
                            class="custom-input-150"
                            formControlName="speurOntwikkelaarVerklaringNummer"
                            id="speurOntwikkelaarVerklaringNummer"
                    ></snelstart-ui-text-form-control>
                </div>
                <div class="col-3"></div>
            </div>

        </div>

        <div *ngIf="heeftWuoStaking" class="row align-items-start">
            <div class="col-7">
                <p>
                    Heeft{{ !partnerBoolean ? dataService.naamAangever : dataService.naamPartner }}
                    in {{ incomeTaxEntity.aangifte?.aangifteJaar }} recht op stakingsaftrek?
                </p>
            </div>
            <div class="col-2">
                <snelstart-ui-select-form-control
                        (change)="saveForm()"
                        [options]="optionsNeeJa"
                        class="custom-input-150"
                        formControlName="krijgtStakingsaftrek"
                        id="krijgtStakingsaftrek"
                ></snelstart-ui-select-form-control>
            </div>
            <div class="col-3"></div>
        </div>

        <div *ngIf="ondernemerForm.get('krijgtStakingsaftrek')?.getRawValue() === true"
             class="row align-items-start">
            <div class="col-7">
                <p>Vul het bedrag aan eerder benutte stakingsaftrek in</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control
                        (change)="saveForm()"
                        [decimals]="0"
                        align="right"
                        class="custom-input-150"
                        formControlName="bedragEerdereBenutteStakingsaftrek"
                        id="bedragEerdereBenutteStakingsaftrek"
                        prefix="€"
                ></snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
        </div>

    </form>

    <form [formGroup]="krijgtWajong">
        <div class="row align-items-start">
            <div class="col-7">
                <p>
                    Heeft {{ !partnerBoolean ? dataService.naamAangever : dataService.naamPartner }}
                    in {{ incomeTaxEntity.aangifte?.aangifteJaar }}
                    recht op de heffingskorting voor jonggehandicapten (wajong)?
                </p>
            </div>
            <div class="col-2">
                <snelstart-ui-select-form-control
                        (change)="saveForm()"
                        [options]="optionsNeeJa"
                        class="custom-input-150"
                        formControlName="krijgtWajong"
                        id="krijgtWajong"
                ></snelstart-ui-select-form-control>
            </div>
            <div class="col-3"></div>
        </div>
    </form>

</div>

<div *ngIf="!heeftOndernemingen()">
    <div *ngIf="!partnerBoolean">
        Er is geen onderneming voor {{ dataService.naamAangever }} ingevuld.
    </div>

    <div *ngIf="partnerBoolean">
        Er is geen onderneming voor {{ dataService.naamPartner }} ingevuld.
    </div>
</div>
